import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioUnselected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 19.65C16.225 19.65 19.65 16.225 19.65 12C19.65 7.77502 16.225 4.35 12 4.35C7.77502 4.35 4.35 7.77502 4.35 12C4.35 16.225 7.77502 19.65 12 19.65ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
		fill: "#49F5A4"
	})
});
export { SvgRadioUnselected as ReactComponent };
